<h1>Deal Desk</h1>

<div class="container my-4">
    @if (dealDesks) {
    @if (canCreate()) {
    <div class="d-flex justify-content-end mb-3">
        <a class="col-5 col-md-3 col-lg-2 btn btn-primary" [routerLink]="['/', 'deal-desk-create']">New Request</a>
    </div>
    }

    <input class="mb-3 form-control" type="text" placeholder="Search Deal Desk Requests" [(ngModel)]="searchText" />

    @for (dealDesk of getFilteredDealDesks(); track dealDesk.id) {
    <div class="card deal-desk-card mb-3 shadow-sm">
        <a class="card-body text-decoration-none text-reset d-block"
            [routerLink]="['/', 'deal-desk-view', dealDesk.id]">

            <!-- Who it is for, and where it stands -->
            <div class="d-flex justify-content-between align-items-start gap-3">
                <h5 class="card-title mb-0">{{ dealDesk.customerName || 'Unknown Customer' }}</h5>
                @if (dealDesk.status) {
                <span class="badge flex-shrink-0" [ngClass]="statusClass(dealDesk.status)">{{
                    statusLabel(dealDesk.status) }}</span>
                }
            </div>

            <!-- Who raised it, and when -->
            <div class="small text-muted mt-1">
                @if (dealDesk.creatorName) {
                <span>{{ dealDesk.creatorName }}</span>
                }
                @if (dealDesk.creatorName && dealDesk.createdAt) {
                <span class="mx-1">&middot;</span>
                }
                @if (dealDesk.createdAt) {
                <span>{{ dealDesk.createdAt | utcToLocal:'short' }}</span>
                }
            </div>

            <!-- Facts wrap and collapse on their own, so a missing one leaves no gap -->
            <div class="deal-desk-facts d-flex flex-wrap mt-3">
                @if (dealDesk.priceType) {
                <div>
                    <div class="fact-label">Price Type</div>
                    <div class="fact-value text-capitalize">{{ dealDesk.priceType }}</div>
                </div>
                }

                @if (dealDesk.procurementStage) {
                <div>
                    <div class="fact-label">Procurement Stage</div>
                    <div class="fact-value">{{ dealDesk.procurementStage }}</div>
                </div>
                }

                @if (dealDesk.discountRequested != null || dealDesk.approvedDiscount != null) {
                <div>
                    <div class="fact-label">Discount</div>
                    <div class="fact-value">
                        @if (dealDesk.discountRequested != null) {
                        <span>{{ dealDesk.discountRequested }}%</span>
                        <span class="fw-normal text-muted small ms-1">requested</span>
                        }
                        @if (dealDesk.discountRequested != null && dealDesk.approvedDiscount != null) {
                        <span class="text-muted mx-2">&rarr;</span>
                        }
                        @if (dealDesk.approvedDiscount != null) {
                        <span class="text-success">{{ dealDesk.approvedDiscount }}%</span>
                        <span class="fw-normal text-muted small ms-1">approved</span>
                        }
                    </div>
                </div>
                }
            </div>

            @if (dealDesk.reviewNote) {
            <div class="border-top mt-3 pt-2">
                <div class="fact-label">Review Note</div>
                <div class="small">{{ dealDesk.reviewNote }}</div>
            </div>
            }
        </a>
    </div>
    }

    } @else {
    <app-loading></app-loading>
    }
</div>
